<template>
  <transition name="modal-fade">
    <div class="modal-backdrop-form">
      <div
        class="modal-form"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
        :style="max_width_style"
      >
        <div v-if="loading">
          <div class="loader"></div>
        </div>

        <div v-else class="row" style="padding-bottom: 0 !important">
          <slot></slot>

          <div class="col-sm-12">
            <div
              class="row m-0 justify-content-between align-items-center"
              style="padding-bottom: 0 !important"
            >
              <div class="p-0 col-auto mr-auto">
                <slot name="footer"></slot>
              </div>
              <div class="p-0 col-auto text-right">
                <button
                  v-if="cancelButton"
                  type="button"
                  class="btn bnt-cancel pr-12"
                  @click="$emit('cancel-clicked')"
                >
                  {{ cancelButton }}
                </button>
                <button
                  v-if="okButton"
                  type="button"
                  class="btn bnt-ok"
                  @click="$emit('ok-clicked')"
                >
                  {{ okButton }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "zmodalform",
  props: {
    cancelButton: {
      type: String,
      default: "",
    },
    okButton: {
      type: String,
      default: "Ok",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 400,
    },
  },
  computed: {
    max_width_style() {
      return `max-width: ${this.width}px`;
    },
  },
};
</script>

<style>
.modal-backdrop-form {
  width: 100%;
  height: 100%;
  background-color: #ffffff84;

  z-index: 99999999;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: scroll;
  display: flex;
  justify-content: center;
  align-content: center;
}

.modal-form {
  /*max-width: 515px;*/
  height: fit-content;
  margin: auto;
  padding: 36px 47px;
  background: #ffffff;
  box-shadow: 0px 2px 8px #4060e324;
  border-radius: 6px;
  /*overflow-x: auto;*/
  /*display: flex;*/
  /*flex-direction: column; *!*/
}

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}

button {
  padding: 16px 21px 18px 21px;
  height: fit-content;
  line-height: 1em;
}

.btn {
  border: none;
  font-size: 10pt;
  padding: 16px 21px 18px;
  cursor: pointer;
  font-weight: bold;
}

.bnt-cancel {
  border: none;
  box-shadow: none;
  font-weight: bold;
  color: #bcbec6;
  background: transparent;
}

.bnt-ok {
}

.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  display: block;
  margin: 0px auto !important;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.align-items-right {
  padding-right: 0;
}
</style>
